var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRearParkingSensor32 = function SvgRearParkingSensor32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.86 7h2.28c1.024 0 2.005.405 2.73 1.127a3.84 3.84 0 0 1 1.13 2.72v8.922a3.22 3.22 0 0 1-.95 2.285 3.246 3.246 0 0 1-2.293.946h-3.514a3.253 3.253 0 0 1-2.293-.946 3.23 3.23 0 0 1-.95-2.285v-8.923a3.834 3.834 0 0 1 1.13-2.72A3.86 3.86 0 0 1 14.86 7v0Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.723 11h2.554c.988 0 1.935.398 2.633 1.106a3.804 3.804 0 0 1 1.09 2.67v3.191c0 .274-.107.537-.298.73a1.01 1.01 0 0 1-.72.303h-7.964a1.01 1.01 0 0 1-.72-.302 1.04 1.04 0 0 1-.298-.73v-3.191a3.8 3.8 0 0 1 1.09-2.67A3.695 3.695 0 0 1 14.723 11v0ZM11 13.643H9m14 0h-2",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 17V8.193a6.22 6.22 0 0 1 1.8-4.38A6.12 6.12 0 0 1 10.145 2h11.71A6.12 6.12 0 0 1 26.2 3.814a6.218 6.218 0 0 1 1.8 4.38v13.613a6.218 6.218 0 0 1-1.8 4.38A6.12 6.12 0 0 1 21.855 28H16m-6 2H8.175a6.084 6.084 0 0 1-4.366-1.863A6.46 6.46 0 0 1 2 23.639V22m8 4h-.912a3.03 3.03 0 0 1-2.177-.927A3.252 3.252 0 0 1 6 22.825V22",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgRearParkingSensor32;